module.exports = __webpack_public_path__ + "sgby/img/lvbu-pic.b5847bf.png";